import { FC } from 'react'

import { SequenceMenu } from '@sequencehq/core-components'

import { ViewWorkflowHistoryMenuItem } from './ViewWorkflowHistory.menuItem'

export const HeaderKebabMenu: FC = () => {
  return (
    <SequenceMenu
      data-testid="automations.management.kebabMenu"
      variant="ghost"
      alignment="bottom-right"
      items={[
        ({ setIsOpen }) => (
          <ViewWorkflowHistoryMenuItem
            key="view-workflow-history"
            onClick={() => setIsOpen?.(false)}
          />
        )
      ]}
    />
  )
}
